export enum ActionRouter {
  RequireAuthorization = "user/requireAuthorization",
  Login = "user/login",
  Logout = "user/logout",
  SetError = "user/setError",
  ClearError = "user/clearError",
  RedirectToRoute = "user/redirectToRoute",
}
